import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, NavController, NavParams } from '@ionic/angular';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { birthdayValidator } from 'src/app/services/customFormValidators';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Navigator } from 'src/app/services/routing/navigator';

@Component({
  selector: 'app-reset-password-verify-second-step',
  templateUrl: './reset-password-verify-second-step.component.html',
  styleUrls: ['./reset-password-verify-second-step.component.scss'],
})
export class ResetPasswordVerifySecondStepComponent implements OnInit {
  // @ViewChild("Content") content: IonContent;

  public error: any = null;
  public step2Form: FormGroup;

  public email: string;
  public pin: string;
  public customerId: string;

  public ssn: AbstractControl;
  public dateOfBirthGroup: AbstractControl;
  public dateOfBirthYear: AbstractControl;
  public dateOfBirthDay: AbstractControl;
  public dateOfBirthMonth: AbstractControl;
  public legalAge: number;
  public isSSNRequired: boolean;
  
  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public authenticationProvider: AuthenticationService,
      public successMessageProvider: SuccessMessageService,
      public config: ConfigService,
      public utils: UtilsService,
      public navigator: Navigator
  ) {
      this.successMessageProvider.clearMessage();

      this.email = this.navParams.get("email");
      this.pin = this.navParams.get("pin");
      this.customerId = this.navParams.get("customerId");
  }

  ngOnInit() {        
    this.legalAge = this.config.getConfig().FEATURE_LEGAL_AGE ?? 21;
    this.isSSNRequired = this.config.getConfig().FEATURE_SIGNUP_SHOW_SSN_FIELD === '1' ? true : false;
      this.step2Form = new FormGroup({
          email: new FormControl(''),
          ssn: new FormControl(({ value: "", disabled: !this.isSSNRequired }), [Validators.required, Validators.minLength(4), Validators.maxLength(4)]),
          dateOfBirthGroup: new FormGroup({
              dateOfBirthYear: new FormControl('', [Validators.required]),
              dateOfBirthDay: new FormControl('', [Validators.required]),
              dateOfBirthMonth: new FormControl('', [Validators.required]),
              hiddenLegalAge: new FormControl(this.legalAge)
          }, birthdayValidator),
      });
      
      if (this.isSSNRequired) this.ssn = this.step2Form.get('ssn');
      this.dateOfBirthGroup = this.step2Form.get('dateOfBirthGroup');    
      this.dateOfBirthYear = this.dateOfBirthGroup.get('dateOfBirthYear');
      this.dateOfBirthDay = this.dateOfBirthGroup.get('dateOfBirthDay');
      this.dateOfBirthMonth = this.dateOfBirthGroup.get('dateOfBirthMonth');

      this.step2Form.get("email").setValue(this.email);
  }

  onSubmit() {
      this.successMessageProvider.clearMessage();
      this.error = null;
      this.step2Form.value.clientapp = this.config.getClientApp();
      this.authenticationProvider.callResetPasswordStep2(this.step2Form.value).subscribe(
          (response: any) => {
              if (response && !!response.result) {
                  this.navigator.navigateTo("ResetPasswordVerifyThirdStepComponent", {}, { email: this.email, pin: this.pin, customerId: this.customerId });
              }
          },
          (error) => {
              this.error = error;
              
              switch (error.getErrorCode().toUpperCase()) {
                  case 'INVALID_DATA':
                      error.setErrorMessage("The information you entered didn't match our records. Please try again.");
                      break;
              }
          }
      );
  }

  openSupport() {
      window.location.assign(``);
      return false;
  }
  
  get months() {
      return ['January','February','March','April','May','June','July','August','September','October','November','December'];
  }

  get days() {
      let days = Array.apply(null, { length: 31 }).map(Number.call, Number)
      return days
          .map(val => val + 1)
          .map(val => (val < 10) ? "0" + val.toString() : val)
  }

  get years() {
      let years = [];
      var min = new Date().getFullYear() - 100,
          max = new Date().getFullYear() - this.legalAge;
      for (var i = max; i >= min; i--) {
          years.push(i)
      }
      return years;
  }
}
